import { useAnalytics } from '@/modules/analytics/hooks/useAnalytics.hook';
import useBounceTracker from '@/modules/analytics/hooks/useBounceTracker.hook';
import PlaygroundForm from '@/modules/playground/components/playground-form';
import usePlayground from '@/modules/playground/hooks/usePlayground.hook';
import { useEffect } from 'react';

const ShareablePreview = () => {
  useBounceTracker();

  const { state } = usePlayground();
  const { captureVisitorMetric } = useAnalytics();

  useEffect(() => {
    if (!state.payload._id) return;
    captureVisitorMetric();
  }, [state.payload._id]);

  return <PlaygroundForm />;
};

export default ShareablePreview;
